import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import Vue from "vue";
//import Utils from '../../scripts/Utils';

const ServiceRepository = RepositoryFactory.get('services');

// initial state
// shape: [{ id, quantity }]
const state = {
    dataToBeSavedOrDeployed: null,
    loading: false,
    deploy_preview_loading: false,
    deploy_live_loading: false,
    deployUpdate: 0,
    deployAll: 0,
    saveManagementRes: null,
};

// getters
const getters = {};

// actions
const actions = {
    async saveManagement({state, commit, rootState}, payload) {
        state.loading = true;
        let {data} = await ServiceRepository.saveManagement(payload);
        commit('updateResponse', data);
        if (data.Status) {
            rootState.display.ignoreSiteUpdate = true;
            rootState.display.ignoreTypeUpdate = true;
            commit('display/updateSelectedType', {data: data.Types.find(x => x.SitetypeId === rootState.display.selectedType.SitetypeId)}, {root: true})
            commit('display/setSiteDetails', {data: data, copyType: false}, {root: true});
            state.deployUpdate++;
        }
        state.loading = false;
        return data;
    },
    async deployPreview({state}, payload) {
        state.deploy_preview_loading = true;
        let {data} = await ServiceRepository.deployPreview(payload);
        /*if (data.Status) {
            state.deployUpdate++;
        }*/
        state.deploy_preview_loading = false;
        return data;
    },
    async deployLive({state, commit}, payload) {
        state.deploy_live_loading = true;
        let {data} = await ServiceRepository.deployLive(payload);
        if (data.Status) {
            //state.deployUpdate++;
            commit('display/updateHistory', data.History, {root: true});
        }
        state.deploy_live_loading = false;
        return data;
    },
};

// mutations
const mutations = {
    updateDeployAll(state, payload) {
        if (state.deployAll !== payload) state.deployAll = payload;
    },
    updateResponse(state, payload) {
        Vue.set(state, "saveManagementRes", payload);
    },
    setLoading(state, payload) {
        Vue.set(state, "loading", payload);
    }
};

export default {
    namespaced: true, state, getters, actions, mutations
}